(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('LabBundleBillingCodeSearch', LabBundleBillingCodeSearch);

    LabBundleBillingCodeSearch.$inject = ['$resource'];

    function LabBundleBillingCodeSearch($resource) {
        var resourceUrl =  'api/_search/lab-bundle-billing-codes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
